module.exports = __webpack_public_path__ + "static/img/prot_red.5bcff68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prot_red.png
// module id = PuLa
// module chunks = 21